import React, { useState, useEffect, useCallback } from 'react';
import { Typography, Card, Button, IconButton } from "@material-tailwind/react";
import Axios from 'axios';
import { MagnifyingGlassIcon, ArrowLeftIcon, ArrowDownIcon } from "@heroicons/react/24/outline";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

// Helpers y Contexto
import { useContextoGlobal } from '../../../Context/contextoGlobal';
import { getToken } from '../../../Helpers/auth-helpers';
import Main from '../../../componentes/Main';
import { useTramites } from '../hooks/useTramites';

// Componentes Locales
import { TablaTramites } from './TablaTramites';
import { TramitesPorUsuario } from './TramitesPorUsuarioOld';
import { QuickSearch } from './QuickSearch';
import {Dialogos} from '../../../componentes/MUI/Dialogos'
import { Tramite } from './Tramite';
import { TramiteNuevo } from './TramiteNuevo';

export const Listado = ({ seleccionarTramite,version }) => {
  const { usuario,esCelular } = useContextoGlobal();
  const { ESTADOS_CONFIG, TIPOS_TRAMITE } = useTramites();

  // Estados de Datos
  const [data, setData] = useState([]);
  const [resumen, setResumen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(true);

  // Estados de Filtros y Búsqueda
//º  const [filtros2, setFiltros2] = useState({ estado: 'Iniciado' });
  const [filtros2, setFiltros2] = useState({});
  const [solicitanteSeleccionado, setSolicitanteSeleccionado] = useState(null);
  const [resultadosBusqueda, setResultadosBusqueda] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [isQuickSearchOpen, setIsQuickSearchOpen] = useState(false);
  const [tramiteSeleccionado,setTramiteSeleccionado] = React.useState(null)
  const [mensajeError,setMensajeError] = React.useState(null)


  useEffect(() => {

   const fetchTramites = async (query) => { // si no quisiera declarar la función dentro del useEffect debería sacarlo, usar un useCallback y ponerlo como dependencia
    const checkQuery = Object.values(query).length>0;

    if (!checkQuery) return 

    setLoading(true);
      const token = getToken();
      try {
        const url = `${process.env.REACT_APP_API_UAD_BASE}/api/tramites/search/true/${token}?${query}`;
        const { data: res } = await Axios.get(url);
        setData(res.listado || []);
        setMensajeError(null)
      } catch (err) {
        console.error("Error al traer trámites:", err);
        setMensajeError(err?.response?.data?.message || 'Se produjo un error al obtener los datos')
      } finally {
        setLoading(false);
      }
  };

    const fetchResumen = async () => { // si no quisiera declarar la función dentro del useEffect debería sacarlo, usar un useCallback y ponerlo como dependencia
        const token = getToken();
        try {
          const { data: res } = await Axios.get(`${process.env.REACT_APP_API_UAD_BASE}/api/tramites/resumen/true/${token}`);
          setResumen(res);
        } catch (err) {
          console.error("Error al traer resumen:", err);
        }
    };

    const params = new URLSearchParams();
    if (filtros2?.estado) params.append('estado', filtros2.estado);
    if (filtros2?.tipo) params.append('tipo', filtros2.tipo);
    if (filtros2?.region) params.append('region', filtros2.region);

    fetchTramites(params.toString());
    fetchResumen();
  }, [filtros2]);

  /* El código comentado es para usarse con el método de useCallback. En lugar de eso yo aplico el método de declarar la función
  dentro del useeffect que lo usa para ahorrarme el usecallback y resolver los bucles infinitos.
  Pero si por algún motivo fetchTramites o fetchResumen se tuvieran que usar fuera del useeffect habría que recurrir al método
  del useCallback y ponerlo como dependencia del useEffect.
  React obliga a que si se usa useCallback se agregue a la función como dependencia para que si cambia la función (por ejemplo si cambia el token)
  se vuelva a ejecutar la función. Yo dejo la versión sin useCallback porque es la que estoy acostumbrado y solo veo como dependencia 
  del useEffect a filtros2 que es lo que dispara a fetchTramites si hay cambios... Es más limpio para mi
  */

  // const fetchTramites = useCallback(async (query) => {
  //   setLoading(true);
  //   const token = getToken();
  //   try {
  //     const url = `${process.env.REACT_APP_API_UAD_BASE}/api/tramites/search/true/${token}?${query || 'estado=Iniciado'}`;
  //     const { data: res } = await Axios.get(url);
  //     setData(res.listado || []);
  //   } catch (err) {
  //     console.error("Error al traer trámites:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, []);

  // const fetchResumen = useCallback(async () => {
  //   const token = getToken();
  //   try {
  //     const { data: res } = await Axios.get(`${process.env.REACT_APP_API_UAD_BASE}/api/tramites/resumen/true/${token}`);
  //     setResumen(res);
  //   } catch (err) {
  //     console.error("Error al traer resumen:", err);
  //   }
  // }, []);

  // useEffect(() => {
  //   const params = new URLSearchParams();
  //   if (filtros2?.estado) params.append('estado', filtros2.estado);
  //   if (filtros2?.tipo) params.append('tipo', filtros2.tipo);
  //   if (filtros2?.region) params.append('region', filtros2.region);

  //   fetchTramites(params.toString());
  //   fetchResumen();
  // }, [filtros2, fetchTramites, fetchResumen]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        setIsQuickSearchOpen(true);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleTramiteClose = (refrescar)=>{setTramiteSeleccionado(null)
                  if (tramiteSeleccionado.origen==='quickSearch') setIsQuickSearchOpen(true)
                  if(refrescar){
                      refrescarTramites()
                  }
    }

  const refrescarTramites = ()=>{
        const copy = {...filtros2}
                     setFiltros2({})
                     setTimeout(() => {
                        setFiltros2(copy)
                     }, 500);
  }

  return (
    <Main>
      {version == '2.0' && <h1 className='text-red-500'>Versión Beta 2.0 (Disponible para Ascensos)</h1>}
      <div className={`flex flex-col md:flex-row w-full min-h-screen relative ${version=='2.0' ? 'bg-red-50' : ' bg-gray-50'}`}>
        <aside className="w-full md:w-80 bg-white border-r border-gray-200 p-4 sticky top-16 h-auto md:h-[calc(100vh-4rem)] overflow-y-auto">
          <div className="mb-6 px-2">
            <Typography variant="h6" color="blue-gray">Panel de selección</Typography>
            <Typography variant="small" className="text-gray-400">
              Filtre por estado o tipo de trámite
            </Typography>
          </div>
          <Button
          variant="outlined"
          size="sm"
          className="flex items-center gap-2 w-full justify-center border-gray-300 text-gray-600 hover:border-blue-500 hover:text-blue-600 transition-all"
          onClick={refrescarTramites}
        >
          <ArrowPathIcon className="h-4 w-4" />
          Refrescar
        </Button>
          <TramitesPorUsuario 
            resumen={resumen}
            data={data}
            filtros2={filtros2}
            setFiltros2={setFiltros2}
            solicitanteSeleccionado={solicitanteSeleccionado}
            setSolicitanteSeleccionado={setSolicitanteSeleccionado}
            isSidebar={true}
          />
        </aside>
        <section className="flex-1 w-full max-w-full overflow-hidden p-4 md:p-8 relative">          
       {version == '2.0' && <h1 className='text-red-500 text-xl p-6'>Probar que se apliquen los mismos condicionales en los nuevos componentes TR*New que los info*</h1>}
       {version == '2.0' && <h1 className='text-red-500 text-xl p-6'>Falta adaptar Primera credencial e implementar Afiliacion y Autonomía. Continuar después de tema inscripciones en efectivo</h1>}

            {Object.keys(filtros2).length == 0 ? (
                <div>
                   <div className='flex items-center mb-4'>
                      <ArrowLeftIcon className="h-4 w-4"/>
                      <Typography variant="small" className="text-gray-400 ml-2">
                            Utilice el panel de selección izquierdo para filtrar trámites
                      </Typography>
                   </div>
                   <div className='flex flex-col items-center justify-center gap-2'>
                      <Typography variant="small" className="text-gray-400">
                            O ejecute una búsqueda rápida
                        </Typography>                    
                        <ArrowDownIcon  className="h-4 w-4"/>
                        <BotonBusquedaRapida setIsQuickSearchOpen={setIsQuickSearchOpen}/>
                   </div>
                </div>
              ):
            (
              <div>
                <BotonBusquedaRapida setIsQuickSearchOpen={setIsQuickSearchOpen}/>

                  <div className="animate-fade-in mt-4">
                      <header className="mb-8">
                        <Typography variant="h3" color="blue-gray" className="tracking-tight">
                          Trámites: <span className="font-bold text-blue-700 bg-blue-50 px-2 py-1 rounded">
                             {filtros2?.estado 
                            ? ESTADOS_CONFIG.find(e => e.value === filtros2.estado)?.label 
                            : TIPOS_TRAMITE.find(t => t.value === filtros2.tipo)?.label || 'General'}
                          </span>
                        </Typography>
                        <div className="h-1 w-20 bg-blue-500 mt-2 rounded-full"></div>
                      </header>

                      <Card className="w-full max-w-full overflow-x-auto shadow-sm border border-gray-200">
                        <TablaTramites 
                          filtro={filtros2?.tipo ? 'tipo' : 'estados'}
                          mensajeError={mensajeError}
                          data={data || []} 
                          loading={loading}
                          seleccionarTramite={(t)=>setTramiteSeleccionado({...t,origen:'dashboard'})} 
                          filtros2={filtros2} 
                        />
                      </Card>
                  </div>
            </div>

            )
        }

        </section>
      </div>

        <QuickSearch 
          isOpen={isQuickSearchOpen}
          onClose={() => setIsQuickSearchOpen(false)}
          onSelect={(t)=>setTramiteSeleccionado({...t,origen:'quickSearch'})}
        />
        <Dialogos open={tramiteSeleccionado} 
                maxWidth={esCelular? '' : 'sm'}
                fullscreen={version== '1.0' ? false : true}
                procesarCancelar = {(refrescar)=>handleTramiteClose(refrescar)}
            >
                {/* {tramiteSeleccionado && 
                    <Tramite id_tramite={tramiteSeleccionado?._id}
                    finalizar={(refrescar)=>handleTramiteClose(refrescar)}
                    />
                } */}
                {version=='1.0' ? 
                (tramiteSeleccionado && 
                    <Tramite id_tramite={tramiteSeleccionado?._id}
                    finalizar={(refrescar)=>handleTramiteClose(refrescar)}
                    />):
                (tramiteSeleccionado && 
                    <TramiteNuevo id_tramite={tramiteSeleccionado?._id}
                    finalizar={(refrescar)=>handleTramiteClose(refrescar)}
                    />)  
              }
                 {/* {tramiteSeleccionado && 
                    <TramiteNuevo id_tramite={tramiteSeleccionado?._id}
                    finalizar={(refrescar)=>handleTramiteClose(refrescar)}
                    /> */}
                
        </Dialogos>         
    </Main>
  );
};


const BotonBusquedaRapida = ({setIsQuickSearchOpen})=>{
     return <Button
                variant="outlined"
                size="sm"
                className="flex items-center gap-2 bg-white border-gray-300 text-gray-400 hover:border-blue-500 lowercase transition-all shadow-sm"
                onClick={() => setIsQuickSearchOpen(true)}
              >
                <MagnifyingGlassIcon className="h-4 w-4" />
                  Búsqueda rápida...
                  <kbd className="ml-2 font-sans font-bold text-[10px] border px-1 rounded bg-gray-50 text-gray-500">Ctrl K</kbd>
              </Button>
}